import { queryOptions } from '@tanstack/react-query';
import * as cuisinesApi from '../endpoints/cuisine';
import { ListCuisinesParams } from '../endpoints/cuisine';
import { Cuisine } from '@/types/cuisine';
import { Paginated } from '@/types/pagination';

export const CUISINES_QUERY_KEYS = {
  all: ['cuisines'] as const,
  lists: () => [...CUISINES_QUERY_KEYS.all, 'list'] as const,
  list: (params: ListCuisinesParams) => [...CUISINES_QUERY_KEYS.lists(), params] as const,
  details: () => [...CUISINES_QUERY_KEYS.all, 'detail'] as const,
  detail: (slug: string) => [...CUISINES_QUERY_KEYS.details(), slug] as const,
} as const;

export const cuisineListQueryOptions = (params: ListCuisinesParams = {}) =>
  queryOptions({
    queryKey: CUISINES_QUERY_KEYS.list(params),
    queryFn: async (): Promise<Paginated<Cuisine>> => cuisinesApi.listCuisines(params),
    staleTime: 1000 * 60 * 15,
    gcTime: 1000 * 60 * 30,
    meta: { persist: true },
  });

export const cuisineDetailQueryOptions = (slug: string) =>
  queryOptions({
    queryKey: CUISINES_QUERY_KEYS.detail(slug),
    queryFn: async (): Promise<Cuisine> => cuisinesApi.getCuisine(slug),
    enabled: !!slug,
    staleTime: 1000 * 60 * 15,
    gcTime: 1000 * 60 * 30,
    meta: { persist: true },
  });
